import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  NumberField,
  TextField,
  ClassificatorField,
  StaticField,
} from '../../atoms';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Row, Col, Checkbox, Button, Spin, Select } from 'antd';
import { fuelsUsedFormFields } from '../../constants/formsAddEquipment';
import { translateFuelTypeClassificator } from '../../utils/translateHelpers';
import { tCommon } from '../../i18n';
import { get } from 'lodash';
import _ from 'lodash';
import RffFields from '../../atoms/rff/RffFields';

const FUEL_TYPE = 'FUEL_TYPE';
const FEEDSTOCK = 'FEEDSTOCK';
const PRODUCTION_PATHWAY = 'PRODUCTION_PATHWAY';

const { Option } = Select;

export default class FuelUnit extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    totalPercentage: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    fetchClassifiers: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    monthlyFuelDataConfirmed: PropTypes.bool.isRequired,
    monthlyGoIssued: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      classifierList: null,
      isLoading: true,
    };
    this.tempKeyCounter = 0;
  }

  componentDidMount = () => {
    const { fetchClassifiers } = this.props;

    const classifiersFetch = async () =>
      await fetchClassifiers(FUEL_TYPE).then((data) =>
        this.setState({
          classifierList: data,
          isLoading: false,
        })
      );

    classifiersFetch();
  };

  renderInput = (fields) => {
    const {
      names,
      max,
      step,
      isFloat,
      precision,
      isOpen,
      min,
      negativeAllowed = false,
      monthlyFuelDataConfirmed,
      monthlyGoIssued,
    } = fields;

    return (
      <div>
        <NumberField
          {...get(fields, names[1]).input}
          max={max}
          min={min}
          negativeAllowed={negativeAllowed}
          precision={precision}
          step={step}
          isFloat={isFloat}
          onChange={(value) => get(fields, names[1]).input.onChange(value)}
          disabled={!isOpen || (monthlyFuelDataConfirmed && monthlyGoIssued)}
          style={{ width: '100%' }}
        />
      </div>
    );
  };

  renderTxtInput = (fields) => {
    const { names, isOpen, monthlyFuelDataConfirmed, monthlyGoIssued } = fields;
    return (
      <div>
        <TextField
          {...get(fields, names[1])}
          onChange={(value) => get(fields, names[1]).input.onChange(value)}
          disabled={!isOpen || (monthlyFuelDataConfirmed && monthlyGoIssued)}
          style={{ width: '100%' }}
        />
      </div>
    );
  };

  renderClassificatorInput = (fields) => {
    const { names, type, isOpen } = fields;

    return (
      <div>
        <ClassificatorField
          {...get(fields, names[1]).input}
          type={type}
          onChange={(value) => get(fields, names[1]).input.onChange(value)}
          disabled={!isOpen}
          style={{ width: '100%' }}
        />
      </div>
    );
  };

  renderClassificator = (fields) => {
    const {
      names,
      type,
      isOpen,
      listData,
      locale,
      monthlyFuelDataConfirmed,
      monthlyGoIssued,
    } = fields;

    const fuelType = get(fields, names[2]).input.value;
    const selectorValue = get(fields, names[1]).input.value;

    const classifierValue = get(listData.lines, fuelType);
    const classifierSub =
      classifierValue !== undefined
        ? get(classifierValue.mapLines, type)
        : undefined;

    let selectOptions;
    let currentValue;

    if (
      classifierSub !== undefined &&
      classifierSub.classifierSubValues !== undefined &&
      get(fields, names[0]).input.value
    ) {
      let currentField = get(classifierSub.classifierSubValues, selectorValue);

      if (currentField !== undefined) {
        currentValue = currentField.code;
      }

      selectOptions = _.map(classifierSub.classifierSubValues, (value) => (
        <Option key={value.code} value={value.code}>
          {get(value.lang, locale)}
        </Option>
      ));
    }

    return (
      <div className={'ant-form-item-control'}>
        <Select
          disabled={!isOpen || (monthlyFuelDataConfirmed && monthlyGoIssued)}
          popupMatchSelectWidth={false}
          value={currentValue}
          onChange={(value) => {
            get(fields, names[1]).input.onChange(value);
          }}
          style={{ width: '100%' }}
        >
          {selectOptions}
        </Select>
      </div>
    );
  };

  renderRawMaterialProperties = (fields) => {
    const {
      names,
      type,
      isOpen,
      listData,
      monthlyFuelDataConfirmed,
      monthlyGoIssued,
    } = fields;

    const fuelType = get(fields, names[2]).input.value;
    const feedstockValue = get(fields, names[1]).input.value;
    const biofuelType = get(fields, names[3]).input.value;

    const classifierValue = get(listData.lines, fuelType);
    const classifierSub =
      classifierValue !== undefined
        ? get(classifierValue.mapLines, type)
        : undefined;
    const classifierSubValue =
      classifierSub !== undefined
        ? get(classifierSub.classifierSubValues, feedstockValue)
        : undefined;

    let selectOptions;
    let currentValue;

    if (
      classifierSubValue !== undefined &&
      classifierSubValue.biofuelTypes !== undefined &&
      get(fields, names[0]).input.value
    ) {
      let currentField = get(classifierSubValue.biofuelTypes, biofuelType);

      if (currentField !== undefined) {
        currentValue = currentField.biofuelType;
      }

      selectOptions = _.map(classifierSubValue.biofuelTypes, (value) => (
        <Option key={value.biofuelType} value={value.biofuelType}>
          {tCommon(`classificators.biofuelType.${value.biofuelType}`)}
        </Option>
      ));
    }

    return (
      <div className={'ant-form-item-control'}>
        <Select
          disabled={!isOpen || (monthlyFuelDataConfirmed && monthlyGoIssued)}
          popupMatchSelectWidth={false}
          value={currentValue}
          onChange={(value) => {
            get(fields, names[3]).input.onChange(value);
          }}
          style={{ width: '100%' }}
        >
          {selectOptions}
        </Select>
      </div>
    );
  };

  renderRawMaterialPropertiesInput = (fields) => {
    const { names, propertyName, translationPrefix } = fields;

    const fuelType = get(fields, names[2]).input.value;
    const feedstockValue = get(fields, names[1]).input.value;
    const biofuelType = get(fields, names[3]).input.value;

    const classifierValue = get(this.state.classifierList?.lines, fuelType);
    const classifierSub =
      classifierValue !== undefined
        ? get(classifierValue.mapLines, FEEDSTOCK)
        : undefined;
    const classifierSubValue =
      classifierSub !== undefined
        ? get(classifierSub.classifierSubValues, feedstockValue)
        : undefined;
    const currentBiofuelType =
      classifierSubValue !== undefined
        ? get(classifierSubValue.biofuelTypes, biofuelType)
        : undefined;

    const computedValue = currentBiofuelType?.[propertyName];
    const inputObj = get(fields, names[4]).input;
    const currentFormValue = inputObj.value;

    if (computedValue !== undefined && computedValue !== currentFormValue) {
      setTimeout(() => inputObj.onChange(computedValue), 0);
    }

    return (
      <div>
        <StaticField
          {...inputObj}
          value={
            computedValue !== undefined
              ? tCommon(`${translationPrefix}${computedValue}`, computedValue)
              : undefined
          }
          disabled={true}
          style={{ width: '100%' }}
        />
      </div>
    );
  };

  renderCheckbox = (fields) => {
    const { names, isOpen, monthlyFuelDataConfirmed, monthlyGoIssued } = fields;

    return (
      <div>
        <Checkbox
          onChange={(e) =>
            get(fields, names[0]).input.onChange(e.target.checked)
          }
          checked={get(fields, names[0]).input.value}
          disabled={!isOpen || (monthlyFuelDataConfirmed && monthlyGoIssued)}
          style={{ width: '100%' }}
        >
          {translateFuelTypeClassificator(get(fields, names[1]).input.value)}
        </Checkbox>
      </div>
    );
  };

  handleAddDuplicate = (index) => {
    const { fields } = this.props;
    const currentValue = fields.value?.[index];
    if (currentValue) {
      this.tempKeyCounter += 1;
      fields.insert(index + 1, {
        ...currentValue,
        [fuelsUsedFormFields.ID]: null,
        _tempKey: `temp-${this.tempKeyCounter}`,
      });
    }
  };

  handleRemove = (index) => {
    const { fields } = this.props;
    fields.remove(index);
  };

  render() {
    const { fields, t, locale, monthlyFuelDataConfirmed, monthlyGoIssued } =
      this.props;

    const items = fields?.value || [];
    // Use isOpen from props (based on production unit status) if provided,
    // otherwise fallback to calculating from form values
    let isOpen = this.props.isOpen;
    if (isOpen === undefined) {
      isOpen = false;
      if (
        items[0] &&
        (items[0].status === undefined || items[0].status === 'OPEN')
      ) {
        isOpen = true;
      }
    }

    const totalPercentage = items
      .filter((item) => item?.[fuelsUsedFormFields.IS_FUEL_USED])
      .reduce(
        (sum, item) =>
          sum + parseInt(item?.[fuelsUsedFormFields.PERCENTAGE] || 0, 10),
        0
      );
    const showCountryFields = false;

    return (
      <Spin spinning={this.state.isLoading}>
        {this.state.isLoading === false && (
          <div style={{ overflowX: 'auto' }}>
            <Row type="flex" gutter={16} className="inline-flex">
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.fuelType')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.percentage')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.posNumber')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.feedstock')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.biofuelType')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.productionPathway')}</h4>
              </Col>
              <Col className="wideTableTitle width-200">
                <h4>{t('fuelsUsed.lowerCalorificValueKg')}</h4>
              </Col>
              <Col className="width-200">
                <h4>{t('fuelsUsed.higherCalorificValueKg')}</h4>
              </Col>
              {showCountryFields === true && (
                <Col className="width-200">
                  <h4>{t('fuelsUsed.feedstockCountry')}</h4>
                </Col>
              )}
              {showCountryFields === true && (
                <Col className="width-200">
                  <h4>{t('fuelsUsed.purchaseCountry')}</h4>
                </Col>
              )}
              <Col className="wideTableTitle width-100">
                <h4>{t('fuelsUsed.calculatedMultiplier')}</h4>
              </Col>
              <Col className="wideTableTitle width-100">
                <h4>{t('fuelsUsed.landUseCategory')}</h4>
              </Col>
              <Col className="wideTableTitle width-100">
                <h4>{t('fuelsUsed.landUseEmissions')}</h4>
              </Col>
            </Row>

            {fields.map((member, index) => {
              const item = items[index];
              const rowId = item?.[fuelsUsedFormFields.ID];
              const tempKey = item?._tempKey;
              const rowKey = rowId != null ? `row-${rowId}` : tempKey || member;

              return (
                <Row
                  key={rowKey}
                  type="flex"
                  gutter={16}
                  className="inline-flex"
                >
                  <Col className="width-200">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                      ]}
                      component={this.renderCheckbox}
                      t={t}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      isOpen={isOpen}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      hasFeedback={false}
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.PERCENTAGE}`,
                      ]}
                      max={100}
                      min={0}
                      precision={0}
                      component={this.renderInput}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      isOpen={isOpen}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      hasFeedback={false}
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.POS_NUMBER}`,
                      ]}
                      component={this.renderTxtInput}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      isOpen={isOpen}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FEEDSTOCK}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                      ]}
                      hasFeedback={false}
                      component={this.renderClassificator}
                      member={member}
                      listData={this.state.classifierList}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      locale={locale}
                      isOpen={isOpen}
                      type={FEEDSTOCK}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FEEDSTOCK}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.BIOFUEL_TYPE}`,
                      ]}
                      hasFeedback={false}
                      component={this.renderRawMaterialProperties}
                      member={member}
                      listData={this.state.classifierList}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      locale={locale}
                      isOpen={isOpen}
                      type={FEEDSTOCK}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.PRODUCTION_PATHWAY}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                      ]}
                      hasFeedback={false}
                      member={member}
                      component={this.renderClassificator}
                      listData={this.state.classifierList}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      locale={locale}
                      isOpen={isOpen}
                      type={PRODUCTION_PATHWAY}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      hasFeedback={false}
                      step={0.1}
                      precision={1}
                      min={0}
                      isFloat
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.LOWER_CALORIFIC_VALUE_KG}`,
                      ]}
                      component={this.renderInput}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      isOpen={isOpen}
                    />
                  </Col>

                  <Col className="width-200">
                    <RffFields
                      hasFeedback={false}
                      step={0.1}
                      precision={1}
                      min={0}
                      isFloat
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.HIGHER_CALORIFIC_VALUE_KG}`,
                      ]}
                      component={this.renderInput}
                      monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                      monthlyGoIssued={monthlyGoIssued}
                      isOpen={isOpen}
                    />
                  </Col>

                  {showCountryFields === true && (
                    <Col className="width-200">
                      <RffFields
                        hasFeedback={false}
                        defaultValue="EESTI"
                        names={[
                          `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                          `${member}.${fuelsUsedFormFields.FEEDSTOCK_COUNTRY}`,
                        ]}
                        component={this.renderClassificatorInput}
                        monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                        monthlyGoIssued={monthlyGoIssued}
                        isOpen={isOpen}
                        type={ClassificatorField.types.country}
                      />
                    </Col>
                  )}
                  {showCountryFields === true && (
                    <Col className="width-200">
                      <RffFields
                        hasFeedback={false}
                        defaultValue="EESTI"
                        names={[
                          `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                          `${member}.${fuelsUsedFormFields.PURCHASE_COUNTRY}`,
                        ]}
                        component={this.renderClassificatorInput}
                        monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                        monthlyGoIssued={monthlyGoIssued}
                        isOpen={isOpen}
                        type={ClassificatorField.types.country}
                      />
                    </Col>
                  )}
                  <Col className="width-100">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FEEDSTOCK}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.BIOFUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.CALCULATED_MULTIPLIER}`,
                      ]}
                      propertyName={fuelsUsedFormFields.CALCULATED_MULTIPLIER}
                      translationPrefix={''}
                      component={this.renderRawMaterialPropertiesInput}
                    />
                  </Col>

                  <Col className="width-100">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FEEDSTOCK}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.BIOFUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.LAND_USE_CATEGORY}`,
                      ]}
                      translationPrefix={'classificators.landUseCategory.'}
                      propertyName={fuelsUsedFormFields.LAND_USE_CATEGORY}
                      component={this.renderRawMaterialPropertiesInput}
                    />
                  </Col>

                  <Col className="width-100">
                    <RffFields
                      names={[
                        `${member}.${fuelsUsedFormFields.IS_FUEL_USED}`,
                        `${member}.${fuelsUsedFormFields.FEEDSTOCK}`,
                        `${member}.${fuelsUsedFormFields.FUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.BIOFUEL_TYPE}`,
                        `${member}.${fuelsUsedFormFields.LAND_USE_EMISSIONS}`,
                      ]}
                      translationPrefix={''}
                      propertyName={fuelsUsedFormFields.LAND_USE_EMISSIONS}
                      component={this.renderRawMaterialPropertiesInput}
                    />
                  </Col>

                  {isOpen && (
                    <>
                      <Col className="width-50">
                        <Button
                          onClick={() => this.handleAddDuplicate(index)}
                          icon={<PlusOutlined />}
                          style={{
                            height: '16px',
                            width: '32px',
                            padding: '0px',
                            margin: '0px',
                            textAlign: 'center',
                            fontWeight: 'bolder',
                            border: 'none',
                          }}
                          disabled={monthlyFuelDataConfirmed && monthlyGoIssued}
                        />
                        <Button
                          onClick={() => this.handleRemove(index)}
                          icon={<MinusOutlined />}
                          style={{
                            height: '16px',
                            width: '32px',
                            margin: '0px',
                            padding: '0px',
                            textAlign: 'center',
                            fontWeight: 'bolder',
                            border: 'none',
                          }}
                          disabled={monthlyFuelDataConfirmed && monthlyGoIssued}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              );
            })}

            <Row type="flex" gutter={32}>
              <Col className="width-200" />
              <Col className="width-200">{totalPercentage} %</Col>
            </Row>
          </div>
        )}
      </Spin>
    );
  }
}
